import React, { useState } from "react";
import CasesInfo from "../../../../components/client/actions/CasesInfo";
import { useSelector } from "react-redux";

export default function Directions() {
  const [caseInfo, setCaseInfo] = useState(false);
  const [caseInfoId, setCaseInfoId] = useState("0");
  const data = useSelector((state) => state.main.data?.instructionsData);
  const handlerClickDir = (id) => {
    setCaseInfo(true);
    setCaseInfoId(`${id}`);
  };

  return (
    <>
      <section className="directions-home">
        <div className="background">
          <img src="/images/BGg.png" alt="" />
        </div>
        <div className="head-title">
          <div className="title">
            <span>تعليمات للمرضى بعد اجراء العمليات </span>
          </div>
        </div>
        <div className="box">
          {data?.map((direction) => (
            <div
              className="direction"
              key={direction?.id}
              onClick={() => handlerClickDir(direction?.id)}
              data-aos="fade-up"
            >
              <div className="image">
                <img
                  src={`https://api.atharalfarasha.com/public/hakim/${direction?.instruction_photo}`}
                  alt=""
                />
              </div>
              <div className="title">{direction?.instruction_name}</div>
            </div>
          ))}
        </div>
      </section>
      <CasesInfo
        setCaseInfo={setCaseInfo}
        caseInfoId={caseInfoId}
        caseInfo={caseInfo}
      />
    </>
  );
}
